import React from "react";
import { Card, TabWrapper, TabItem } from "legion-ui";
import { navigate } from "gatsby";

const TabbarHorizontal = () => {
  const handleClickTab = () => navigate("https://legion.telkom.design/");
  return (
    <div style={{ marginBottom: "30px", width: "630px" }}>
      <Card style={{ paddingLeft: "24px" }}>
        <TabWrapper style={{ marginRight: "24px" }} tabName="tabOne">
          <TabItem id="tab4" label="Product" isActive={true} />
          <TabItem id="tab5" label="Detail" icon="Info" isDisabled={true} />
          <TabItem id="tab6" label="Variant" />
          <TabItem id="tab7" label="Color Option" badgeNumber="4" />
          <TabItem id="tab8" label="Link Action" onClick={handleClickTab} />
          <TabItem id="tab9" label="Term and Condition" />
        </TabWrapper>
      </Card>
    </div>
  );
};

export default TabbarHorizontal;
